import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ComfortableDensityIcon, CompactDensityIcon } from './icons';
import { useTranslation } from 'react-i18next';
import { useDensity, type Density } from '@/context/density-context';

const OPTIONS: ReadonlyArray<{ value: Density; Icon: typeof ComfortableDensityIcon }> = [
  { value: 'comfortable', Icon: ComfortableDensityIcon },
  { value: 'compact', Icon: CompactDensityIcon },
];

/** Comfortable / Compact selector; the choice persists (see DensityProvider). */
export function DensitySelect({ fullWidth = false }: { fullWidth?: boolean }) {
  const { t } = useTranslation();
  const { density, setDensity } = useDensity();

  return (
    <ToggleButtonGroup
      value={density}
      exclusive
      fullWidth={fullWidth}
      size="small"
      color="standard"
      aria-label={t('density.label')}
      onChange={(_event, next: Density | null) => {
        if (next) setDensity(next);
      }}
    >
      {OPTIONS.map(({ value, Icon }) => (
        <ToggleButton key={value} value={value} aria-label={t(`density.${value}`)}>
          <Icon size={20} />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
